"use client";

import Link from "next/link";
import { useActionState } from "react";

import { login, type LoginState } from "./actions";

const initialState: LoginState = null;

const monoLabel =
  "mb-2 block font-paw-mono text-[11px] tracking-[0.16em] text-(--paw-steel-faint)";

// Ported from auth/login.blade.php's form. `remember` is kept for parity but is
// a no-op until the credentials flow wires it.
export function LoginForm() {
  const [state, formAction, pending] = useActionState(login, initialState);

  return (
    <form
      action={formAction}
      className="flex flex-col"
      style={{ maxWidth: "26rem", gap: "22px" }}
    >
      <div>
        <label htmlFor="email" className={monoLabel}>
          EMAIL
        </label>
        <input
          id="email"
          name="email"
          type="email"
          required
          autoFocus
          autoCapitalize="off"
          autoCorrect="off"
          spellCheck={false}
          autoComplete="email"
          placeholder="you@example.com"
          className="paw-field"
        />
      </div>

      <div>
        <label htmlFor="password" className={monoLabel}>
          PASSWORD
        </label>
        <div
          className="flex"
          style={{
            border: "1px solid var(--paw-line-strong)",
            background: "var(--paw-panel)",
          }}
        >
          <input
            id="password"
            name="password"
            type="password"
            required
            autoComplete="current-password"
            className="min-w-0 flex-1 border-0 bg-transparent px-3.5 py-3 text-[14px] text-white focus:outline-none"
          />
          <button
            type="button"
            data-toggle-password='{"target":"#password"}'
            className="paw-password-toggle border-l px-3.5 font-paw-mono text-[11px] tracking-[0.12em] text-(--paw-steel-faint) hover:text-(--paw-steel)"
            style={{ background: "transparent", borderColor: "var(--paw-line)" }}
          >
            <span className="paw-eye-open">SHOW</span>
            <span className="paw-eye-closed">HIDE</span>
          </button>
        </div>
      </div>

      <div className="flex items-center justify-between gap-4">
        <label
          htmlFor="remember"
          className="flex cursor-pointer items-center gap-2.5 font-paw-mono text-[11px] tracking-[0.12em] text-(--paw-steel-dim) select-none"
        >
          <input
            id="remember"
            type="checkbox"
            name="remember"
            className="h-4 w-4"
            style={{ accentColor: "var(--paw-signal)" }}
          />
          REMEMBER ME
        </label>
        <Link
          href="/forgot-password"
          className="font-paw-mono text-[11px] tracking-[0.12em] text-(--paw-steel-dim) transition hover:text-(--paw-paper)"
        >
          FORGOT PASSWORD?
        </Link>
      </div>

      {state?.error ? (
        <div
          role="alert"
          className="border border-(--paw-danger) bg-(--paw-danger-wash) px-4 py-3 font-paw-mono text-[12px] text-(--paw-paper)"
        >
          {state.error}
        </div>
      ) : null}

      <button
        type="submit"
        disabled={pending}
        className="paw-btn w-full disabled:opacity-60"
        style={{ padding: "17px" }}
      >
        {pending ? "SIGNING IN…" : "SIGN IN"}
      </button>
    </form>
  );
}
